var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectPayout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_710_3031",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_710_3031)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -0.999939,
    width: 32.5926,
    height: 32.5926,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_710_3031",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_710_3031",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAB2AAAAdgB+lymcgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARSSURBVHic7Zo7aBVBFIa/+EJQUAwGBRU0GsRoY6EIPsAHCFrYiBZqEZ+dWCjYWdoovgoflTYqaGchakSDhTYqamKwEETwmfi4JhYmeC1mxuzdnJmdvXt3797c/DDsvTNnzpzzz+zO2TkLdY6GahtQYRQ9ZEp8HpOSIaPICaYDL1Arw5S6QRPwEuW0udYNAcGZfw3MoI4IkJyHOiHA5jzUAQEu52GEExDlPIxgAnycH7EYdZ46cX42cAMoAL3AdeAVQ0FOU/VMSx+zUU4XhTLinQc185LzReBaFe3KDAXsBPQmVV4Lr8N/HG1jkyrPMwGNwDlgikPmXhaGbAAuAd1Any6vgYvA+hTGGw8cBL6hlvkA8m3QCyxIYfz/aAEeCgOHy4MKGrIJRbTRfRtYpPXfBH7qcqOCY4pYzdAMSKcp0mys8tA7B7gKfEQ5chPlyCKUs0ZfN4qMqqAF2XkXAYaE+Q69s4AvQr8CapkX9bgHUbdB1SAt+9/AvoDMfl0Xlrvv0HtFkDdlAPXAa6ygH2VhA7KBuwXZPRbZdSG5GbpOmn1TeirsR9m4hGzgVN3+RBd0nSR7QbevwR7ChsuPCLts/RIjHAfYHmST9PUxsFQP/t0iu1pfPwHTUPf1I6DTYUcm+7kPbGHnqYDMAtTbmG1WClpuLDAz0G8e8m3gs5+ntgLCcMXd10OGnrbIFbCjWevpId5+nhkBwSBEGmgA5TiobU2S7UrBrsyeAR0WOROPPwWW6d99FlmbjprAemSm9wiyey2ya1OwK7NbAFRsLwVC+wMyB5ADofaUbMqUgLnA14gBpbaoUDiIuA6F5Z4Bmy2yR4D+gGw/cNjTrv9YhRzE2AzqAVbG0J+EgGfAZIdsP8P1unYmK+ajYnubscFl3xxTdxICNuq6nZROkkv385j2lWAdKrztAn7p0gmcp/wHXhICTFjeY+kr6T1epp2pIQkBc3Xdc4eecFlTcQ8SIgkBh3RdK/DZocuUH1T5fEFCEgL6gMW6fiHwwaGviAq3c4ek2+AXYIluiyJBOsuoOpISECahbOQ5LxCF6cCWtJTHnaG09Uuyb4CJqC8/2x06Oyjji9haIMAkZdoc+kxpq4aBacpf1vWNDD9lkvr0EjONnmcCgs5cduiwkeaFPBNgXsvXAn8D9VG5i7/ECN3zSsBbYBwqsgsf3/nkLrp1/0jklYBj+v8uoa9v7mJHUHGtxQEmf7BNaPPNXWz3GSivK8DkDqWXIN/cxUfHOJk7FFfefBIzaOnvk7sYdIyTuUNx5c3xvJTAMYjKXZQcj9XaM2COvr4X2nxzF++Cf2qNAHMOcEdo26qvy4EVobogpL7DkNdb4Jb+38rw54BP7mIQ9TlOJPJKwABDZ4JnI3RIbcGdwom8ElBEvfo2ABNQcYEvAXeJcTaYZwKKwFFdPwE4g31bNKvmFDEPRvNOQJHSs/5W4CTq63GTu3gJnMDznh/FKOoU/wDKf94lqAxgQwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPayout);
export default __webpack_public_path__ + "static/media/project_payout.00305b1b661442240e6fcc5e4ce2f76b.svg";
export { ForwardRef as ReactComponent };